<template>
  <div id="app">
    <PetCalculatorForm />
  </div>
</template>

<script>
import PetCalculatorForm from './components/PetCalculatorForm.vue';

export default {
  name: 'App',
  components: {
    PetCalculatorForm
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>